import { render } from "./OnboardingQuestions.vue?vue&type=template&id=3960da46"
import script from "./OnboardingQuestions.vue?vue&type=script&lang=js"
export * from "./OnboardingQuestions.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__